import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const MessagesRaw = React.lazy(() => import(/* webpackChunkName: "MessagesPage" */ './Messages'));
export const Messages = () => (React.createElement(Page, { title: "Messages", description: "Manage Inbox" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(MessagesRaw, null)))));
